import React, { FC, memo } from 'react';

import PolicyTag, { PolicyTagProps } from './PolicyTag';
import SkeletonItem from '../SkeletonItem';

const PolicyTagWithSkeleton: FC<PolicyTagProps> = ({
    title, fid, handleMenuClick, policyClickAction, isLocked, showTooltip,
}) => (
    title
        ? (
            <PolicyTag
                title={title}
                fid={fid}
                handleMenuClick={handleMenuClick}
                policyClickAction={policyClickAction}
                isLocked={isLocked}
                showTooltip={showTooltip}
            />
        )
        : <SkeletonItem />
);

export default memo(PolicyTagWithSkeleton);
